import { storyOverview } from "@/mocks/anime";

export default function StorySection() {
  return (
    <section id="story" className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-16">
      <div className="flex flex-col items-start justify-between gap-3 md:flex-row md:items-end">
        <div>
          <span className="text-sm font-medium text-primary-600">STORY</span>
          <h2 className="font-heading mt-1 text-2xl text-foreground-900 md:text-3xl">剧情概览</h2>
        </div>
        <p className="max-w-md text-sm leading-6 text-foreground-600">
          整部作品围绕「秘密」与「选择」两大关键词展开，四条主线相互交织，共同撑起一个关于成长与羁绊的故事。
        </p>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {storyOverview.map((item, idx) => (
          <article
            key={item.title}
            className="group relative overflow-hidden rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-200"
          >
            <span className="font-heading text-4xl text-primary-200 transition-colors group-hover:text-primary-300">
              {String(idx + 1).padStart(2, "0")}
            </span>
            <h3 className="mt-3 text-base font-medium text-foreground-900">{item.title}</h3>
            <p className="mt-2 text-sm leading-6 text-foreground-600">{item.text}</p>
          </article>
        ))}
      </div>
    </section>
  );
}